import { MoneyBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { toPositiveNumber } from './functions/toPositiveNumber';

export const BrokerShareField = () => {
    const value = useStandardLoanStore((state) => state.loan.brokerShare);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <MoneyBox
            id='loanBrokerShare'
            value={value}
            onChange={(amount) => updateLoan({ brokerShare: toPositiveNumber(amount) })}
            label='Broker Share'
            displayChange={true}
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
